/**
 *
 * ResultsItem
 *
 */

import React, { memo, FunctionComponent } from 'react';
import helmetIcon from '../../../../assets/icons/helmet.svg';
import horseIcon from '../../../../assets/icons/horse.svg';
import { EventType, LiveFeedEventResult } from '../../../../domain';

interface IProps {
  result: LiveFeedEventResult;
  type?: EventType;
  sjPhasesCount: number;
  disabledFields: string[];
  desktopVisible: boolean;
  mobileVisible: boolean;
  tabletVisible: boolean;
  isScoringEntered?: boolean;
}

const ResultsItem: FunctionComponent<IProps> = ({
  result,
  sjPhasesCount,
  disabledFields,
}) => {
  const isEnabled = (field: string) => {
    return !disabledFields.includes(field);
  };
  const phases = [...Array(sjPhasesCount)];

  return (
    <tr>
      <td>{isEnabled('eaEventClassAndSort') && result.eaEventClassAndSort}</td>
      <td>{isEnabled('sectionName') && result.sectionName}</td>
      <td>
        {isEnabled('bridleNumber') && (
          <div className="fw-7">{result.bridleNumber}</div>
        )}
      </td>
      <td>
        <div className="d-flex align-items-center text-nowrap">
          <img src={helmetIcon} className="mr-11" alt="" />
          <div className="fs-12 fw-7">
            {result.riderFirstName} {result.riderLastName}
          </div>
        </div>
      </td>
      <td className="horse-detailed">
        <div className="d-flex align-items-center">
          <img src={horseIcon} className="mr-11" alt="" />
          <div className="d-flex flex-column">
            <div className="fs-12 fw-7 text-nowrap">
              {result.customHorseName || result.horseName}
            </div>
            <div className="fs-12 txt-secondary">
              Owner: {result.ownerFirstName} {result.ownerLastName}{' '}
            </div>
          </div>
        </div>
      </td>
      {phases.map((_, index) => (
        <React.Fragment key={index}>
          <td>
            {isEnabled(`phase${index + 1}JF`) && (
              <div>{result[`phase${index + 1}JF`]}</div>
            )}
          </td>
          <td>
            {isEnabled(`phase${index + 1}TF`) && (
              <div>{result[`phase${index + 1}TF`]}</div>
            )}
          </td>
          <td>
            {isEnabled(`phase${index + 1}F`) && (
              <div>{result[`phase${index + 1}F`]}</div>
            )}
          </td>
          <td>
            {isEnabled(`phase${index + 1}RecTime`) && (
              <div>{result[`phase${index + 1}RecTime`]}</div>
            )}
          </td>
        </React.Fragment>
      ))}

      <td>
        {isEnabled('totalJFaults') &&
          result.isScoringEntered &&
          result.totalJFaults}
      </td>
      <td>
        {isEnabled('sectionPlace') && (
          <div className="fw-7">{result.sectionPlace}</div>
        )}
      </td>
      <td>
        {isEnabled('sjPlace') && <div className="fw-7">{result.sjPlace}</div>}
      </td>
      <td width="100px">
        {isEnabled('riderClassStatusCode') && (
          <div className="fw-7 fs-12">{result.riderClassStatusCode}</div>
        )}
      </td>
    </tr>
  );
};

export default memo(ResultsItem);
